import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NgClass } from '@angular/common';
import { DEFAULT_EVENT_LOGO } from '../../constants/constants';

@Component({
  selector: 'app-entity-logo',
  templateUrl: './entity-logo.component.html',
  styleUrls: ['./entity-logo.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [NgClass],
})
export class EntityLogoComponent {
  @Input() logo: string | null = null;
  @Input() small: boolean = false;

  get src(): string {
    return this.logo ?? DEFAULT_EVENT_LOGO;
  }
}
